import { gql } from "@apollo/client";
import { PROMO_DETAIL_FRAGMENT } from "./getPromoDetail";
export const UPDATE_PROMO_PROGRAM = gql`
  ${PROMO_DETAIL_FRAGMENT}
  mutation UpdatePromoProgram($params: UpdatePromoProgramInput!) {
    updatePromoProgram(params: $params) {
      ...PromoDetailFields
    }
  }
`;
